import { gql } from '@apollo/client';
import { ErrorFragment } from '../fragments';
import { TileFieldsFragment } from './fragments';

export const ADD_TILE = gql`
  mutation AddTile($input: TileAddInput!) {
    tileAdd(input: $input) {
      errors {
        ...ErrorFields
      }
      entity {
        ...TileFields
      }
    }
  }
  ${ErrorFragment}
  ${TileFieldsFragment}
`;

export const DELETE_TILE = gql`
  mutation DeleteTile($input: TileDeleteInput!) {
    tileDelete(input: $input) {
      errors {
        ...ErrorFields
      }
      entity {
        ...TileFields
      }
    }
  }
  ${ErrorFragment}
  ${TileFieldsFragment}
`;

export const UPDATE_TILE = gql`
  mutation UpdateTile($input: TileUpdateInput!) {
    tileUpdate(input: $input) {
      errors {
        ...ErrorFields
      }
      entity {
        ...TileFields
      }
    }
  }
  ${ErrorFragment}
  ${TileFieldsFragment}
`;
